import React, { useState, useEffect } from "react";
import { instance2 } from ".././utils/axiosInstance";
import { ReactComponent as EditIcon } from "../img/editicon.svg";
import { ReactComponent as VerticalLine } from "../img/verticalline.svg";
import { ReactComponent as MagnificationLogo } from "../img/magnificationlensicon.svg";
import { useLocation, useNavigate } from "react-router-dom";
import { formatNumber } from "../numberingformat";
import { Button } from "../shadcn/button";
import { Input } from "../shadcn/input";

export default function TabelLaporanProduksi({dashboard}) {
  const localDateString = (thedate) => {
    const year = thedate.getFullYear();
    const month = String(thedate.getMonth() + 1).padStart(2, "0"); // Adding 1 because months are 0-based
    const day = String(thedate.getDate()).padStart(2, "0");

    return `${year}-${month}-${day}`;
  };
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [searchQuery, setSearchQuery] = useState(""); // Search input state
  const roleId = parseInt(localStorage.getItem("roleId"), 10);
  const { pathname } = useLocation();
  const isDashboard = pathname === "/";

  // Pagination States
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = isDashboard ? 5 : 15;

  // Edit Modal States
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [editedQtyReal, setEditedQtyReal] = useState("");
  const kitchenId = localStorage.getItem("kitchenId");
  const locationId = localStorage.getItem("locationId");
  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        let url;
        kitchenId
          ? (url = `/kitchen_result/${kitchenId}`)
          : (url = `/kitchen_result/location/${locationId}`);

        const response = await instance2.get(url);
        setData(response.data);
      } catch (err) {
        setError(err.message || "Failed to fetch data");
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  const filteredData = data.filter((item) => {
    const formattedDate = new Date(item.date)
      .toLocaleDateString("id-ID", {
        day: "2-digit",
        month: "long",
        year: "numeric",
      })
      .toLowerCase();

    const search = searchQuery.toLowerCase();

    return (
      String(item.qty_real ?? "")
        .toLowerCase()
        .includes(search) ||
      String(item.qty_sch ?? "")
        .toLowerCase()
        .includes(search) ||
      formattedDate.includes(search) ||
      (item.kitchen_name ?? "").toLowerCase().includes(search)
    );
  });

  const totalPages = Math.ceil(filteredData.length / itemsPerPage);
  const paginatedData = filteredData.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage,
  );

  const handlePreviousPage = () => {
    if (currentPage > 1) setCurrentPage(currentPage - 1);
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) setCurrentPage(currentPage + 1);
  };
  // Determine which page numbers to show
  let pageNumbers = [];
  const maxVisiblePages = isDashboard ? 3 : 5;

  if (totalPages <= maxVisiblePages) {
    pageNumbers = Array.from({ length: totalPages }, (_, i) => i + 1);
  } else {
    if (currentPage <= (isDashboard ? 2 : 3)) {
      // Near the beginning
      pageNumbers = isDashboard
        ? [1, 2, 3, "...", totalPages]
        : [1, 2, 3, 4, 5, "...", totalPages];
    } else if (currentPage >= totalPages - 2) {
      // Near the end
      pageNumbers = isDashboard
        ? [1, "...", totalPages - 3, totalPages - 2, totalPages - 1, totalPages]
        : [
            1,
            "...",
            totalPages - 4,
            totalPages - 3,
            totalPages - 2,
            totalPages - 1,
            totalPages,
          ];
    } else {
      // In the middle
      pageNumbers = [
        1,
        "...",
        currentPage - 1,
        currentPage,
        currentPage + 1,
        "...",
        totalPages,
      ];
    }
  }
  // const handleEditClick = (item) => {
  //   setSelectedItem(item);
  //   setEditedQtyReal(item.qty_real);
  //   setIsEditModalOpen(true);
  // };

  const handleSaveEdit = async () => {
    if (!selectedItem) return;

    try {
      const updatedData = {
        qty_real: editedQtyReal,
        admin_id: localStorage.getItem("userId"),
      };

      await instance2.put(
        `/dish_production/kitchen/${selectedItem.id}`,
        updatedData,
      );

      // Update local state
      setData((prevData) =>
        prevData.map((item) =>
          item.id === selectedItem.id
            ? { ...item, qty_real: editedQtyReal }
            : item,
        ),
      );

      setIsEditModalOpen(false);
    } catch (error) {
      console.error("Failed to update qty_real:", error);
      alert("Failed to update data. Please try again.");
    }
  };

  const [sortConfig, setSortConfig] = useState({ key: "", direction: "asc" }); // Sort state
  const handleSort = (key) => {
    const newDirection =
      sortConfig.key === key && sortConfig.direction === "asc" ? "desc" : "asc";
    const sortedData = [...data].sort((a, b) => {
      if (a[key] < b[key]) return newDirection === "asc" ? -1 : 1;
      if (a[key] > b[key]) return newDirection === "asc" ? 1 : -1;
      return 0;
    });
    setData(sortedData);
    setSortConfig({ key, direction: newDirection });
  };

  const getSortArrow = (key) => {
    if (sortConfig.key === key) {
      return sortConfig.direction === "asc" ? "▲" : "▼";
    }
    return "";
  };

  return (
    <div className="p-4">
      <div className="@container">
        <div className="flex flex-col @xl:flex-row gap-2 mb-4 items-center justify-between w-full">
          <h2 className=" text-xl sm:text-2xl font-medium text-balance text-center">
            Hasil Produksi
          </h2>
          <div className="grid grid-flow-col w-full @xl:w-auto gap-2">
           {([3, 4, 5].includes(roleId) && dashboard) ? (
  <Button
    className="w-full @xl:w-auto overflow-x-hidden whitespace-pre-wrap"
    onClick={() => navigate("/weeklyreport")}
  >
    Laporan Produksi
  </Button>
) : ([3, 4, 5].includes(roleId) && !dashboard) ? (
  <button
    type="button"
    onClick={() => navigate("/weeklyreport")}
    className="rounded-[25px] px-8 py-4 bg-merah-no hover:bg-merah-hover text-white text-xxs md:text-xxs lg:text-base"
  >
    Laporan Produksi
  </button>
) : null}

            {roleId === 3 ? (
              <Button
                className="w-full @xl:w-auto overflow-x-hidden whitespace-pre-wrap"
                onClick={() => navigate("/tambahhasilproduksi")}
              >
                Tambah Data Produksi
              </Button>
            ) : (
              ""
            )}
          </div>
        </div>

        {loading && (
          <div className="flex justify-center py-8">
            <div className="w-6 h-6 border-2 border-gray-300 border-t-blue-500 rounded-full animate-spin"></div>
          </div>
        )}
        {error && <div className="text-center text-red-500">{error}</div>}

        {!loading && !error && data.length === 0 && (
          <p className="text-gray-500 text-center sm:text-xs md:text-xs lg:text-base">
            Tidak ada data yang tersedia
          </p>
        )}

        {!loading && !error && data.length > 0 && (
          <div className="flex flex-col overflow-x-auto gap-4">
            {/* Search Bar */}

            <div className="flex items-center relative w-full">
              <Input
                type="text"
                placeholder="Telusuri data"
                value={searchQuery} // Controlled input
                onChange={(e) => setSearchQuery(e.target.value)} // Update search query
                className="flex rounded-full p-2 pl-10"
                    style={{
                      // width: `${"Telusuri data Telusuri".length}ch`,
                    }}
              />
              <div className="flex items-center gap-2 absolute left-2">
                <MagnificationLogo className="size-4" />
                <VerticalLine />
              </div>
            </div>

            <table className="min-w-full border-collapse">
              <thead className="bg-gray-200">
                <tr className="bg-white">
                  {/* <th className="border-b px-4 py-2">No</th> */}
                  {/* <th className="border-b px-4 py-2 text-left ">Lokasi</th> */}

                  <th
                    className="border-b px-4 py-2 text-left text-xxs md:text-xxs lg:text-base cursor-pointer rounded-tl-[15px]"
                    onClick={() => handleSort("date")}
                  >
                    Tanggal{" "}
                    <span className="float-right">{getSortArrow("date")}</span>
                  </th>
                  {roleId !== 3 ? (
                    <th
                      className="border-b px-4 py-2 text-left text-xxs md:text-xxs lg:text-base cursor-pointer"
                      onClick={() => handleSort("kitchen_name")}
                    >
                      Dapur{" "}
                      <span className="float-right">
                        {getSortArrow("kitchen_name")}
                      </span>
                    </th>
                  ) : (
                    ""
                  )}

                  <th
                    className="border-b px-4 py-2 text-right text-xxs md:text-xxs lg:text-base cursor-pointer"
                    onClick={() => handleSort("qty_sch")}
                  >
                    Rencana{" "}
                    <span className="float-right">
                      {getSortArrow("qty_sch")}
                    </span>
                  </th>

                  <th
                    className={`border-b px-4 py-2 text-right text-xxs md:text-xxs lg:text-base cursor-pointer ${roleId === !3 ? " rounded-tr-[15px]" : ""}`}
                    onClick={() => handleSort("qty_real")}
                  >
                    Realisasi{" "}
                    <span className="float-right">
                      {getSortArrow("qty_real")}
                    </span>
                  </th>
                  {roleId === 3 ? (
                    <th className="border-b px-4 py-2 text-xxs md:text-xxs lg:text-base rounded-tr-[15px]">
                      Aksi
                    </th>
                  ) : (
                    ""
                  )}
                </tr>
              </thead>
              <tbody>
                {paginatedData.map((item, index) => (
                  <tr
                    key={item.id}
                    className={
                      index % 2 === 0 ? "bg-transparent" : "bg-gray-50"
                    }
                  >
                    {/* <td className="border-b px-4 py-2 text-center">{index + 1}</td> */}

                    <td className="border-b px-4 py-2 text-xxs md:text-xxs lg:text-base">
                      {new Date(item.date).toLocaleDateString("id-ID", {
                        year: "numeric",
                        month: "long",
                        day: "2-digit",
                      })}
                    </td>
                    {roleId !== 3 ? (
                      <td className="border-b px-4 py-2 text-xxs md:text-xxs lg:text-base">
                        {item.kitchen_name}
                      </td>
                    ) : (
                      ""
                    )}
                    {/* <td className="border-b px-4 py-2">{item.location_name}</td> */}
                    <td className="border-b px-4 py-2 text-right text-xxs md:text-xxs lg:text-base">
                      {formatNumber(item.qty_sch)}
                    </td>
                    <td className="border-b px-4 py-2 text-right text-xxs md:text-xxs lg:text-base">
                      {formatNumber(item.qty_real)}
                    </td>
                    {roleId === 3 ? (
                      <td className="border-b px-4 py-2 text-center text-xxs md:text-xxs lg:text-base">
                        <button
                          onClick={() =>
                            navigate(
                              `/tambahhasilproduksi?date=${localDateString(new Date(item.date))}`,
                            )
                          }
                          className="text-gray-500 p-2 rounded hover:text-green-500"
                        >
                          <EditIcon className="w-4 h-4 md:w-4 md:h-4 lg:w-5 lg:h-5" />
                        </button>
                      </td>
                    ) : (
                      ""
                    )}
                  </tr>
                ))}
              </tbody>
            </table>

            <div className="flex justify-center items-center mt-4 text-xs sm:text-sm">
              {/* Previous Button */}
              <button
                className={`px-2 py-2 rounded ${
                  currentPage === 1
                    ? "text-gray-400 cursor-not-allowed"
                    : "text-gray-500 hover:text-black"
                }`}
                onClick={handlePreviousPage}
                disabled={currentPage === 1}
              >
                <span className="font-bold text-lg sm:text-2xl">{"<"}</span>
              </button>

              {/* Page Numbers */}
              <div className="flex items-center">
                {pageNumbers.map((page, index) => (
                  <span
                    key={index}
                    onClick={() =>
                      typeof page === "number" && setCurrentPage(page)
                    }
                    className={`mx-1 px-2 sm:px-3 py-1 cursor-pointer rounded-full ${
                      currentPage === page
                        ? "text-black font-semibold"
                        : "text-gray-700"
                    } ${page === "..." ? "cursor-default text-gray-400" : ""}`}
                  >
                    {page}
                  </span>
                ))}
              </div>

              {/* Next Button */}
              <button
                className={`px-2 py-2 rounded ${
                  currentPage === totalPages
                    ? "text-gray-400 cursor-not-allowed"
                    : "text-gray-500 hover:text-black"
                }`}
                onClick={handleNextPage}
                disabled={currentPage === totalPages}
              >
                <span className="font-bold text-lg sm:text-2xl">{">"}</span>
              </button>
            </div>
          </div>
        )}

        {isEditModalOpen && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center">
            <div className="bg-white p-6 rounded-lg">
              <h2 className="text-lg font-bold mb-4">
                Ubah Kuantitas Realisasi
              </h2>
              <input
                type="number"
                value={editedQtyReal}
                onChange={(e) => setEditedQtyReal(e.target.value)}
                className="border p-2 w-full"
              />
              <div className="flex justify-end gap-4 mt-4">
                <button
                  onClick={() => setIsEditModalOpen(false)}
                  className="bg-gray-300 px-4 py-2 rounded"
                >
                  Batal
                </button>
                <button
                  onClick={handleSaveEdit}
                  className="bg-blue-500 text-white px-4 py-2 rounded"
                >
                  Simpan
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
